// extracted by mini-css-extract-plugin
export var container = "container-module--container--1fQX9";